import './bootstrap';
import 'bootstrap';

import {registerSW} from 'virtual:pwa-register';
registerSW({immediate: true});

// In an installed PWA (standalone) there is no browser chrome, so target="_blank"
// cannot escape the window to show an inline PDF. Force document links to download instead.
function isStandalone() {
    return window.matchMedia?.('(display-mode: standalone)').matches === true
        || window.navigator.standalone === true; // iOS home-screen webapp
}

if (isStandalone()) {
    document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href*="/dokumente/"]');
        if (!link) return;
        const url = new URL(link.href, location.origin);
        url.searchParams.set('download', '1'); // server -> Content-Disposition: attachment (iOS ignores the download attr)
        link.href = url.toString();
        link.setAttribute('download', '');      // OS download manager (Android Chrome, same-origin)
        link.removeAttribute('target');         // avoid a chrome-less blank window
    }, {capture: true});
}

import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';
window.Chart = Chart;

// Auto-focus first input with 'modal-autofocus' class when modal opens
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.modal').forEach(function(modal) {
        modal.addEventListener('shown.bs.modal', function() {
            const autofocusElement = modal.querySelector('.modal-autofocus');
            if (autofocusElement) {
                autofocusElement.focus();
            }
        });
    });
});
